import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Community from './pages/Community';
import Library from './pages/Library';
import Journal from './pages/Journal';
import Bracket from './pages/Bracket';
import Focus from './pages/Focus';
import Auth from './pages/Auth';
import StaffLogin from './pages/StaffLogin';
import Profile from './pages/Profile';
import RequireAuth from './components/RequireAuth';
import { BookProvider } from './context/BookContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';

// Landing screen for "/": logged-in members land on their own Sanctuary
// ("Me"), everyone else (including guests) sees the public Community page.
const Landing = () => {
  const { user } = useAuth();
  return user ? <Dashboard /> : <Community />;
};

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <BookProvider>
          <Router>
            <Routes>
              <Route path="/auth" element={<Auth />} />
              <Route path="/staff/login" element={<StaffLogin />} />
              {/* Shelf was merged into Library as its primary view (2026-08-12) */}
              <Route path="/shelf" element={<Navigate to="/library" replace />} />
              <Route path="/" element={<Layout />}>
                <Route index element={<Landing />} />
                <Route path="community" element={<Community />} />
                <Route path="me" element={<RequireAuth><Dashboard /></RequireAuth>} />
                <Route path="library" element={<RequireAuth><Library /></RequireAuth>} />
                <Route path="journal" element={<RequireAuth><Journal /></RequireAuth>} />
                <Route path="bracket" element={<RequireAuth><Bracket /></RequireAuth>} />
                <Route path="focus" element={<RequireAuth><Focus /></RequireAuth>} />
                <Route path="profile" element={<RequireAuth><Profile /></RequireAuth>} />
              </Route>
            </Routes>
          </Router>
        </BookProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;